import React from "react";
import { Link } from "react-router-dom";
import { artists, explore } from "../../route-link";
import { IArtwork } from "../../types/artwork/artwork";
import { IImage } from "../../types/imageData";
import ArtworkNoticeAudited from "./audited-components/ArtworkNoticeAudited/ArtworkNoticeAudited";

interface VoteArtworkNotificationProps {
  nameFrom: string;
  userId: string;
  time: Date;
  artwork: IArtwork;
  userImage: IImage;
}

const VoteArtworkNotification: React.FC<VoteArtworkNotificationProps> = ({
  nameFrom,
  userId,
  time,
  artwork,
  userImage,
}): JSX.Element => {
  return (
    <div className="notification_grid">
      <div className="notification_text">
        <Link
          className="notification_link"
          to={`${explore}/${artists}/${userId}`}
          state={{ name: nameFrom, image: userImage }}
        >
          {nameFrom}
        </Link>{" "}
        voted for artwork
      </div>
      <ArtworkNoticeAudited artwork={artwork} time={time} />
    </div>
  );
};

export default VoteArtworkNotification;
